import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import cls from './styles.scss';
import Text from '../../elementals/text';
const cx = classnames.bind(cls);
const AddressInfo = ({ address, elmId, className, isCancelled = false }) => {
    const addressArray = address || [];
    const addressLine1 = addressArray[0];
    const addressLine2 = addressArray[1];
    const textBodyProps = {
        weight: 'normal',
        color: 'gray',
    };
    return (_jsxs("div", { className: cx('address-container'), children: [_jsx(Text.Body, { as: 'h3', size: 'small', ...textBodyProps, "data-elm-id": `address_line_1_${elmId}`, className: cx('property-address-line-1', className), children: !isCancelled ? addressLine1 : '' }), _jsx(Text.Body, { as: 'h3', size: 'small', ...textBodyProps, "data-elm-id": `address_line_2_${elmId}`, className: cx('property-address-line-2', className), children: addressLine2 })] }));
};
AddressInfo.propTypes = {
    address: PropTypes.array,
    elmId: PropTypes.string,
    className: PropTypes.string,
    isCancelled: PropTypes.bool,
};
export default AddressInfo;
//# sourceMappingURL=index.js.map